import { makeType, parseOptions, initLog } from "../core/base"

import { Transform } from "../core/transform"

import { maybe } from "../core/functions"

import Dispatcher from "../core/dispatcher-flyd"

import UI from "../core/ui"

// export default class PanelSwapper extends UI.Base {
const proto = {
  name: "PanelSwapper",
  parseOptions,
  initLog,

  setDefaults() {
    this.options = {
      // duration: ".6",
      // timing: "ease-in-out",
      interval: 6000,
      hideControls: true,
      usekeys: false,
      panelRole: 'panel-swapper-panel',
      controlRole: 'panel-swapper-control',
      controlSetRole: 'panel-swapper-controls',
      debug: false
    }
  },

  initialize(dom) {
    this.dom = dom
    this.initLog()
    this.setDefaults()
    this.parseOptions()

    // this.log.enable();
    this.log.trace("dom: ", dom)

    this.panels = this.dom.findByRole(this.options.panelRole)

    this.panels.forEach((p, idx) => {
      if (idx === 0) {
        // not necessary if stylesheet is correct
        p.addClass("slideshow-slide-first")
        this.showPanel(p)
      } else {
        this.hidePanel(p)
      }
      // Transform.setDuration(p, this.options.duration);
      // Transform.setTimingFunction(p, this.options.timing);
    })

    maybe((duration) => {
      this.log.warn(`duration: ${duration}`)
      this.panels.forEach((p) => {
        Transform.setDuration(p, duration)
      })
    })(this.options.duration)

    maybe((timing) => {
      this.log.warn(`timing: ${timing}`)
      this.panels.forEach((p) => {
        Transform.setTimingFunction(p, timing)
      })
    })(this.options.timing)

    // const controlSets = this.dom.findByRole(this.options.controlSetRole)
    // const self = this

    // if (controlSets === []) {
    //   this.controls = this.dom.findByRole(this.options.controlRole)
    //   if (this.controls.length < 1) {
    //     // controls might be elsewhere on the page. not in this dom branch
    //     this.controls = document
    //       .findByRole(this.options.controlRole)
    //       .filter(c => c.dataset.target === this.dom.id)
    //   }

    //   this.controls.forEach((p, idx) => {
    //     p.addEvent('click', () => {
    //       self.showPanel(self.panels[idx])
    //     })
    //   })

    // } else {
    //   this.dom.findByRole(this.options.controlSetRole)
    //   .map(cs => {
    //     cs
    //     .findByRole(this.options.controlRole)
    //     .forEach((p, idx) => {
    //       p.addEvent('click', () => {
    //         self.showPanel(self.panels[idx])
    //       })
    //     })
    //   })
    // }

    this.dom
    .findByRole(`panel-swapper-controls`)
    .forEach((set) => this.initializeControls(set))


    Dispatcher.map((msg) => {
      // this.log.warn(`msg:`, {... msg})
      switch (msg.type) {
        case "show-panel-image":
          this.showPanelById(msg.id)
          break
      }

      //     case "popup-active":
      //       this.stopAutoPlay();
      //     case "popup-disabled":
      //     case "popup-inactive":
      //       this.resetAutoPlay();
      //       break;
      //   }
    })
  },

  initializeControls(controlset) {
    const self = this
    let controls = controlset.findByRole(this.options.controlRole)

    if (controls.length < 1) {
      // controls might be elsewhere on the page. not in this dom branch
      controls = document
        .findByRole(this.options.controlRole)
        .filter((c) => c.dataset.target === this.dom.id)
    }

    controls.forEach((p, idx) => {
      p.addEvent("click", () => {
        self.showPanel(self.panels[idx])
      })
    })
  },

  showPanelById(id) {
    this.panels
      .filter((panel) => panel.dataset.image_id === `${id}`)
      .forEach((panel) => {
        this.showPanel(panel)
      })
  },

  showPanel(p) {
    if (p == null)
      return

    this.panels
      .filter((panel) => panel !== p)
      .forEach((panel) => {
        this.hidePanel(panel)
      })

    p.removeClass("hidden")
    p.addClass("visible")
    return this
  },

  hidePanel(p) {
    p.addClass("hidden")
    p.removeClass("visible")
    return this
  },
}

const PanelSwapper = makeType(proto)
export default PanelSwapper

UI.register("panel-swapper", PanelSwapper)
